import isAxiosError from './isAxiosError';

export default isAxiosError;
